import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

const PrivacyPolicy = () => {
  const classes = useStyles();
  return (
    <div className="Static">
      <h2 className="Static__heading">Privacy Policy</h2>
      <div className={classes.root}>
        <p>
          We, at Nutri-Asia, Inc., value and respect your privacy. We thank you
          for joining our Shop Saya Rewards Program and for taking time and
          interest in browsing the terms and conditions of said campaign. This
          Privacy Policy will explain to you as to: (1) how we will process and
          handle personal information you may provide us whenever you register
          with our campaign, subscribe to any of their features, participate in
          any of the activities posted for the campaign, or do any act in
          connection with our campaign which may entail you disclosing personal
          information; and (2) choices available to you in terms of managing
          your personal information.
        </p>

        <p>
          By joining our Program, hence, enrolling/registering as a user in our
          Shop Saya platform, you consent to the collection, use, sharing to our
          affiliates, branch offices, related companies, authorized vendors,
          agents and representatives, and disclosure of your personal
          information in accordance with this Privacy Policy.
        </p>

        <h4>What information do we collect?</h4>
        <p>We collect information from you when you fill out an entry form.</p>
        <p>
          When you fill out a form as appropriate, you may be asked to enter
          your: name, email address, birthday and mobile number. Other
          information may also be collected in order to complete the application
          for our Program.
        </p>

        <h4>Where do we use your information for?</h4>
        <p>
          We collect and use your personal data for the purpose of providing our
          services to you, providing information to our affiliates, branch
          offices, related companies, authorized vendors, agents and
          representatives, and for marketing. We may also use your personal
          information for secondary purposes closely related to the foregoing
          primary purposes, in circumstances where you would reasonably expect
          such use or disclosure. These secondary purposes are as follows:
        </p>

        <ul>
          <li>
            To be able to provide services and continuously improve through
            analysis of available data based on consumer transaction;
          </li>
          <li>
            To process and answer inquiries or to contact you to answer your
            questions and/or requests;
          </li>
          <li>
            To develop and improve our products, services, communication methods
            and the functionality of our platform.
          </li>
          <li>To continuously improve our services and product offerings;</li>
          <li>
            For the purposes of joining or processing entries to competitions or
            promotions you enter;
          </li>
          <li>
            To communicate information to you and to manage your registration
            and/or subscription to our newsletter or other communications;
          </li>
          <li>
            To authenticate the identity of individuals contacting us by
            telephone, electronic means or otherwise;
          </li>
          <li>
            To understand and assess the interests, wants, and changing needs of
            consumers, to improve our website, our current products and
            services, and/or developing new products and services; and
          </li>
          <li>
            To provide personalised products, communications and targeted
            advertising as well as product recommendations to you;
          </li>
          <li>For profiling consumers;</li>
          <li>
            For marketing and information and promotion dissemination purposes;
          </li>
          <li>
            To comply with legal requirements (if there are any and if
            applicable);
          </li>
        </ul>
        <p>
          You may withdraw your consent to the processing of your personal
          information at any time by contacting us in writing through the
          contact information provided below.
        </p>

        <h4>
          By submitting your information, you provide consent to Nutri-Asia,
          Inc. to do the following:
        </h4>
        <ul className="consent">
          <li>
            Collect and process your personal data, as provided under applicable
            laws, regulations, and Nutri-Asia, Inc.’s policies, for its and its
            affiliates’ and partners’ valid and legitimate purposes;
          </li>
          <li>
            Make your personal data available to Nutri-Asia, Inc. affiliates and
            partners for them to process the personal data for valid and
            legitimate purposes as indicated above.; and
          </li>
          <li>
            Make your personal data available, and to permit Nutri-Asia, Inc.’s
            affiliates and partners also to make your personal data available:
          </li>
          <ol>
            <li>
              To third parties who provide products or services to Nutri-Asia,
              Inc. or its affiliates and partners for the same valid and
              legitimate purposes as described above; and
            </li>
            <li>
              To other third parties, where required or permitted by law,
              including regulatory authorities, government agencies, as well as
              parties with whom you voluntarily transact.
            </li>
          </ol>
          <li>
            Use the necessary information according to the our Cookies Terms and
            Conditions page.
          </li>
        </ul>
        <h4>How do we protect your information?</h4>
        <p>
          In accordance with the provisions of Republic Act No. 10173 or the
          Data Privacy Act of 2012 (“RA 10173”), Nutri-Asia, Inc. and its
          affiliates and partners shall implement reasonable and appropriate
          organization, technical, and physical security measures to protect the
          confidentiality, integrity, and availability of your personal
          information.
        </p>

        <h4>Do we use cookies?</h4>
        <p>
          Yes, we use cookies. Kindly click here to view term and conditions for
          this.
        </p>

        <h4>
          Accessing Your Personal Information and Your Rights as a Data Subject
        </h4>
        <p>
          You, as the data subject, have rights under RA 10173, which include
          the following:
        </p>
        <ul className="list">
          <li>(1) The right to access;</li>
          <li>(2) The right to rectification or to make corrections;</li>
          <li>
            (3) The right to object to the processing of your personal
            information;
          </li>
          <li>
            (4) The right to erasure or blocking of your personal information;
          </li>
          <li>
            (5) The right to be informed of the existence of processing of your
            personal information;
          </li>
          <li>(6) The right to data portability;</li>
          <li>(7) The right to damages; and</li>
          <li>
            (8) The right to file a complaint before the National Privacy
            Commission.
          </li>
        </ul>
        <h4>Contacting Us</h4>
        <p>
          If you have questions regarding this Privacy Policy or have any
          questions or concerns related to how we process your personal
          information, you may contact us using the information below:
        </p>
        <p>Nutri-Asia, Inc. – Data Protection Officer</p>
        <p>
          Office address: 9F JY Campos Centre, 9th Avenue corner 30th Street
          Bonifacio Global City, Taguig
        </p>
        <p>
          Email address:{" "}
          <a href="mailto: dpo_nai@nutriasia.com">dpo_nai@nutriasia.com</a>
        </p>
        <p>Phone number: 856-2131</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
